export const renew = {

	needFormFatcaEUA : '',
	haveRenews : false,
}
